import {
    getAdvancedFeatures,
    getBreadcrumbs,
    getContactUs,
    getExclusions,
    getHeader,
    getLaunch,
    getMaxDiff,
    getOperationalQuotas,
    getNotifications,
    getTranslations,
    getImportProject,
    getUser,
    handleAdvancedFeaturesIndications,
    handleRedirectToLogin,
    getGtag,
    getBetaSuggestion,
    initOptions,
    getWalkMe,
} from './utils/initializer';
import { checkIsExternalLink } from './utils/url.service';
import { InitOptions, TCPApi } from './modules/common/models/common.models';
import { useEvent } from './modules/common/hooks/useEvent.hook';
import {
    addAuthorizationHeader,
    deleteAuthorizationHeader,
    getAuthorizationHeader,
} from "./modules/common/services/network.service";

function init(config: InitOptions) {
    initOptions(config);
    handleRedirectToLogin();
    handleAdvancedFeaturesIndications();
    getGtag().init();
    getWalkMe().init(config);
}

const TCP: TCPApi = {
    init,
    user: getUser() as TCPApi['user'],
    breadcrumbs: getBreadcrumbs(),
    advancedFeatures: getAdvancedFeatures() as TCPApi['advancedFeatures'],
    contactUs: getContactUs(),
    RequestDemo: getContactUs(),
    header: getHeader(),
    launch: getLaunch(),
    exclusions: getExclusions(),
    translations: getTranslations(),
    importProject: getImportProject(),
    notifications: getNotifications(),
    maxDiff: getMaxDiff(),
    operationalQuotas: getOperationalQuotas(),
    gtag: getGtag(),
    betaSuggestion: getBetaSuggestion(),
    utils: {
        isExternalUrl: checkIsExternalLink,
        useEvent
    },
    networkService: {
        addAuthorizationHeader,
        deleteAuthorizationHeader,
        getAuthorizationHeader,
    },
    walkMe: getWalkMe(),
};

window.tcp = TCP;

export default {
    ...TCP,
};
